export default "__VITE_ASSET__deafc070__"